import React, { Component } from "react";
import MUIDataTable from "mui-datatables";
import Button from '@material-ui/core/Button';
import { fetchNotifAll } from "api/notification/index";

class NotifList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      datatable: this.props.datatable
    };
  }

  render() {
    const columns = [
      {
        name: "id",
        label: "id",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "dateNotif",
        label: "Date Announcement",
        options: {
          filter: false
        }
      },
      {
        label: "Header Text",
        name: "headerText",
        options: {
          filter: true
        }
      },
      {
        label: "Footer Text",
        name: "footerText",
        options: {
          filter: true
        }
      },
      {
        name: "bodyText",
        label: "Body Text",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "Action",
        options: {
          filter: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            let id = (tableMeta.rowData !== undefined) ? tableMeta.rowData[0]:0
            return (
              <div>
                <Button variant="outlined" color="secondary" onClick={() => this.props.handleDelete(id)}>
                  Delete
                </Button>
                <Button variant="outlined" color="primary" onClick={()=>this.props.restate(tableMeta.rowData)} >
                  Update
                </Button>
              </div>
            );
          }
        }
      }
    ];

    const options = {
      filter: false,
      //filterType: "dropdown",
      selectableRows: false,
      responsive: "scroll",
      textLabels: {
        body: {
          noMatch: this.props.loader ? "Searching..." : "Sorry, no matching records found"
        }
      }
    };

    return (
      <MUIDataTable
        title={"Notification"}
        data={this.props.datatable}
        columns={columns}
        options={options}
      />
    );
  }
}

export default NotifList;
